import PropTypes from "prop-types";
import {useRouter} from "next/router";
import Image from "next/image";
import {Fragment} from "react";

const LinksBlock = ({links}) => {
  const {basePath, locale: currentLocale} = useRouter();

  return (
    <div className="page-blog__link-block">
      {links.map((item, id) =>
        <Fragment key={id}>
          {(id !== 0 && id !== links.lenght) &&
            <Image src={`${basePath}/images/chevron-right.svg`} width={14} height={14} alt=""/>}
          <a className="page-blog__link" href={currentLocale === 'en' ? item.link :`/${currentLocale}${item.link}`}>{item.text}</a>
        </Fragment>,
      )}
    </div>
  );
};

LinksBlock.propTypes = {
  links: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
  })).isRequired,
};

export default LinksBlock;
